import { ActionTypes } from '../constants/index';

export function login(credentials: Object): Object {
  return {
    type: ActionTypes.SESSION_LOGIN_REQUEST,
    payload: { credentials },
  };
}

export function logout(): Object {
  return {
    type: ActionTypes.SESSION_LOGOUT_REQUEST,
    payload: {},
  };
}

export function signup(credentials: Object): Object {
  return {
    type: ActionTypes.SESSION_SIGNUP_REQUEST,
    payload: { credentials },
  };
}


export function resetPassword(credentials: Object): Object {
  return {
    type: ActionTypes.SESSION_RESET_REQUEST,
    payload: { credentials },
  };
}


export function forgotPassword(credentials: Object): Object {
  return {
    type: ActionTypes.SESSION_FORGOT_REQUEST,
    payload: { credentials },
  };
}

export function refreshFCMToken(device: Object): Object {
  return {
    type: ActionTypes.SESSION_REGISTERFCM_REQUEST,
    payload: device,
  };
}


/*
  code, state, scope
*/
export function sendLoginOAuthCode(oAuthInfo: Object): Object {
  return {
    type: ActionTypes.SESSION_LOGIN_AUTH_CODE_REQUEST,
    payload: { oAuthInfo },
  };
}

export function sendSignupOAuthCode(oAuthInfo: Object): Object {
  return {
    type: ActionTypes.SESSION_SIGNUP_AUTH_CODE_REQUEST,
    payload: { oAuthInfo },
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/session.js